module.exports = __webpack_public_path__ + "img/ico_business_1.6d9227b0.svg";